import * as React from 'react'
import { connect } from 'react-redux'

import { getClientId, getLanguage, getBaseUrl } from '../reducers/config';
import { getPlayerIdsByMatchId } from '../reducers/matches';
import { getActiveChannelId } from '../reducers/gui';
import { getMatchIdByChannelId } from '../reducers/timings';

import PlayerProfilesPresentation from '../presentations/PlayerProfiles/PlayerProfilesPresentation';

const mapStateToProps = ( state: any ) => {
    const channelId: any = getActiveChannelId( state );
    const matchId: number = getMatchIdByChannelId( state, channelId );

    return {
        clientId: getClientId( state ),
        lang: getLanguage( state ),
        baseUrl: getBaseUrl( state ),
        activeChannelId: getActiveChannelId( state ),
        teamId: getPlayerIdsByMatchId( state, matchId )
    }
};

export default connect(mapStateToProps)(PlayerProfilesPresentation);
